import { freeze } from "immer";

function r(path: string) {
  return freeze({ path, to: () => path } as const, true);
}

export const routes = freeze(
  {
    landing: r("/"),
    legal: r("/legal"),
    privacy: r("/privacy"),
    terms: r("/terms"),
    login: r("/app/login"),
    verifyEmailLink: r("/app/auth/verify"),
    myAccount: r("/app/my-account"),
    producers: r("/app/producers"),
    producerDetail: { path: "/app/producers/:id", to: (id: string | number) => `/app/producers/${id}` },
    producerDetailEdit: {
      path: "/app/producers/:id/edit",
      to: (id: string | number) => `/app/producers/${id}/edit`,
    },
    recipes: r("/app/recipes"),
    recipeDetail: { path: "/app/recipes/:id", to: (id: string | number) => `/app/recipes/${id}` },
    recipeDetailEdit: {
      path: "/app/recipes/:id/edit",
      to: (id: string | number) => `/app/recipes/${id}/edit`,
    },
    recipeDetailVersion: {
      path: "/app/recipes/:id/version/:version",
      to: (id: string | number, version: string | number) => `/app/recipes/${id}/version/${version}`,
    },
    ingredients: r("/app/ingredients"),
    ingredientDetail: { path: "/app/ingredients/:id", to: (id: string | number) => `/app/ingredients/${id}` },
    ingredientDetailEdit: {
      path: "/app/ingredients/:id/edit",
      to: (id: string | number) => `/app/ingredients/${id}/edit`,
    },
    ingredientDetailVersion: {
      path: "/app/ingredients/:id/version/:version",
      to: (id: string | number, version: string | number) => `/app/ingredients/${id}/version/${version}`,
    },
  } as const,
  true,
);
